import { appendLocalMessage, CHAT_FLOW_STEPS, ChatAPI } from '@guuru/chat-web';
import events from '@guuru/events-web';

// Handles greeting,
export default async function () {
  events.greeting();
  ChatAPI.storeQuestion();

  const message = await ChatAPI.addBotMessage('chat:::greeting', true);
  appendLocalMessage(message);
  return {
    goToStep: CHAT_FLOW_STEPS.chatQuestion,
  };
}
